module.exports = __webpack_public_path__ + "Lato-Heavy.72c6dd530f0acc74b528.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/Lato/fonts/Lato-Heavy.ttf
// module id = ../../../../../src/assets/fonts/Lato/fonts/Lato-Heavy.ttf
// module chunks = styles